// Authenticate Module
import * as forge from 'node-forge'
import { auth as auth_api } from './api'

const sha256 = x => forge.sha256.create().update(x).digest().toHex();
const decode64 = x => forge.util.decodeUtf8(forge.util.decode64((x || '').replace(/_/g, '/').replace(/-/g, '+')));

const auth = {
  profile: undefined, // From JWT's payload (JSON obj)
  token: undefined, // JWT, itself
  exp: undefined, // Token expire timestamp
  isAuthenticated: () => { return !_.isEmpty(auth.profile) && auth.exp > new Date().getTime() / 1000; },

  // login
  login: async (username, password) => {
    let p = { username: username, password: sha256(password), ts: new Date().valueOf() }
    try {
      let rs = await auth_api.login(p);
      if(!rs || typeof(rs) !== 'string' || !auth.resolve(rs)) { throw { status: 301, data : rs }; }

      sessionStorage.setItem('token', rs);
      console.log('[svc] auth', 'login()', 'success');
      return true;
    } catch(e) {
      console.log('[svc] auth', 'login()', 'failed', e.status, e.data);
      throw e;
    }
  },
  // logout, flush session storage and reset this object.
  logout: () => {
    auth.profile = auth.token = auth.exp = undefined;
    sessionStorage.removeItem('token');
    auth_api.unsetAuth();
  },
  refresh: async () => {
    try {
      let rs = await auth_api.refresh();
      if(!rs || typeof(rs) !== 'string' || !auth.resolve(rs)) { throw { status: 301, data : rs }; }
      sessionStorage.setItem('token', rs);
      console.log('[svc] auth', 'refresh()', 'success');
      return true;
    } catch(e) {
      auth_api.unsetAuth();
      console.log('[svc] auth', 'refresh()', 'failed', e, e.status, e.data);
      return false;
    }
  },
  resolve: (token) => {
    let ts = {}, rs = [];
    try {
      rs = token.split('.');
      if(rs.length != 3) { return false; }
      let info = decode64(rs[1]);
      ts = JSON.parse(info.replace(/\0/g, '')) || {};
      if(_.isEmpty(ts) || !ts.exp || ts.exp < new Date().getTime() / 1000) { return false; }
    } catch(e) { return false; }
    auth.token = token;
    auth.profile = ts.profile;
    auth.exp = ts.exp;
    auth_api.setAuth(token);
    return true;
  },
  init: async () => {
    if(auth.resolve(sessionStorage.getItem('token'))) {
      console.log('[svc] auth', 'init()', 'stored token found, verifying.');
      try {
        if(!await auth.refresh()) { throw null; }
        console.log('[svc] auth', 'init()', 'token verified.');
      }
      catch { console.log('[svc] auth', 'init()', 'verifying failed.'); }
    } else {
      console.log('[svc] auth', 'init()', 'stored token not found.');
    }
  },
  has_permission: (permission = []) => { return _.isEmpty(permission) || auth.profile && _.includes(permission, auth.profile.permission); }
}

export default auth